import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import eatful from "../../assets/home/eatful-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import whatsapp from "../../assets/whatsapp/whatsapp.png"
/* Animation style (runs once) */
const style = document.createElement("style");
style.innerHTML = `
@keyframes slideOut {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(0); }
}
`;
document.head.appendChild(style);

const Header = () => {
  const { cartCount } = useCart();

  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  /* Get user from localStorage on load */
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  /* Logout */
  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const handlemyorder = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.id) {
      alert("Please login first");
      navigate("/login");
      return;
    }

    navigate(`/myorders/${user.id}`);
  };


  /* 🔥 CART CLICK → FORCE PAGE RELOAD */
  const handleCartClick = (e) => {
    e.preventDefault();

    // if (window.location.pathname === "/cart") {
    //   window.location.reload(); // already on cart → reload
    // } else {
    //   window.location.href = "/cart"; // go to cart + reload
    // }
    navigate("/cart");
  };

  return (
    <>
     
      <div
        style={{
          position: "fixed",
          bottom: "70px",
          right: "20px",
          zIndex: 1099,
        }}
      >
        <a
          href="https://wa.me/917872006000"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={whatsapp}
            alt="whatsapp"
            style={{
              width: "40px",
              height: "40px",
              cursor: "pointer",
            }}
          />
        </a>
      </div>
    
    <header className="shadow-sm">
      <nav className="navbar navbar-expand-lg py-2" style={{ background: "white" }}>
        <div className="container-fluid px-3 px-md-4">

          {/* LOGO */}
          <Link className="navbar-brand fw-bold fs-3" to="/">
            <img
              src={eatful}
              alt="Eatful logo"
              className="img-fluid"
              style={{ width: "80px", height: "50px" }}
            />
          </Link>

          {/* CENTER MENU */}
          <div style={{ fontWeight: "700" }}>
            <ul
              style={{
                listStyle: "none",
                display: "flex",
                gap: "15px",
                fontSize: "17px",
                textTransform: "uppercase",
                marginBottom: 0,
              }}
            >
              <li>
                <Link to="/about" style={{ color: "black", textDecoration: "none" }}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/store" style={{ color: "black", textDecoration: "none" }}>
                  Store
                </Link>
              </li>
              <li>
                <Link to="/contact" style={{ color: "black", textDecoration: "none" }}>
                  Gifting
                </Link>
              </li>
            </ul>
          </div>

          {/* MOBILE TOGGLE */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarResponsive"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* RIGHT SIDE */}
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-2 text-center text-lg-start">

              {/* USER LOGIN / EMAIL */}
              <li className="nav-item dropdown">
                {!user ? (
                  <Link className="nav-link fw-semibold" to="/login">
                    <i className="bi bi-person fs-4 text-dark"></i>
                  </Link>
                ) : (
                  <>
                    <a
                      className="nav-link dropdown-toggle fw-semibold"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {user.email}
                    </a>

                    <ul className="dropdown-menu dropdown-menu-end">
                      <li>
                        <button
                          className="dropdown-item text-danger"
                          onClick={handlemyorder}
                        >
                          my orders
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item text-danger"
                          onClick={handleLogout}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </>
                )}
              </li>

              {/* 🛒 CART */}
              <li className="nav-item position-relative">
                <a
                  href="/cart"
                  className="nav-link fw-semibold"
                  onClick={handleCartClick}
                >
                  <i className="bi bi-cart fs-4 text-dark"></i>

                  {cartCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "-5px",
                        background: "red",
                        color: "white",
                        fontSize: "12px",
                        borderRadius: "50%",
                        width: "18px",
                        height: "18px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {cartCount}
                    </span>
                  )}
                </a>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </header>
    </>
  );
};

export default Header;
